/**
 * Platform staff roles for `/admin`, login redirect, maintenance bypass.
 * Case-insensitive — some DBs store `Admin` or legacy `platform_admin`.
 */
export function isPlatformAdminRole(role: string | null | undefined): boolean {
  const r = typeof role === "string" ? role.trim().toLowerCase() : "";
  return r === "admin" || r === "super_admin" || r === "platform_admin";
}
